if (!customElements.get('cart-drawer-recommend')) {

  class CartDrawerRecommend extends HTMLElement {
    constructor() {
      super();

      const loaderElm = this.querySelector('[data-bought-together-loader]');

      // Initialize recommendations when the browser resize
      this.screenType = window.innerWidth < 768 ? 'mobile' : 'desktop';
      window.addEventListener('resize', () => {
        if (!document.querySelector('body').classList.contains('cart-drawer-is-open')) {
          return;
        }
        if (window.innerWidth < 768 && this.screenType !== 'mobile') {
          this.screenType = 'mobile';
          this.classList.add('reload');
          this.initRecommendations();
        }
        if (window.innerWidth >= 768 && this.screenType !== 'desktop') {
          this.screenType = 'desktop';
          this.classList.add('reload');
          this.initRecommendations();
        }
      });

      // If the element has the loading class, initialize the recommendations directly
      if (this.classList.contains('reload')) {
        this.initRecommendations();
      }

    }

    async initRecommendations() {
      // Only initialize when the element is not loaded with the latest data
      if (this.classList.contains('loaded') && !this.classList.contains('reload')) {
        return;
      }

      // Remove the loading class
      //loaderElm.classList.remove('loader');

      // Only initialize if the element is visible on the screen
      const type = this.getAttribute('data-type') || 'desktop';
      if (type === 'desktop' && this.screenType == 'mobile') {
        this.classList.add('not-in-view');
        return;
      }
      if (type === 'mobile' && this.screenType == 'desktop') {
        this.classList.add('not-in-view');
        return;
      }
      this.classList.remove('not-in-view');

      // Initialize the Recommended products
      this.initRecommendedProducts();

    }

    /**
     * Initialize the Recommended products
     * @param {object}
     * @returns {void}
     */
    initRecommendedProducts() {
      try {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;

          observer.unobserve(productRecommendationsSection);

          const url = productRecommendationsSection.dataset.url;

          fetch(url)
            .then(response => response.text())
            .then(text => {

              if(text !== 'undefined' && text !== 'null' && text !== '') {
                const html = document.createElement('div');
                html.innerHTML = text;
              }

              const recommendations = html.querySelector('.product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;
              }

              const loaderElm = this.querySelector('[data-bought-together-loader]');
              if (loaderElm) {
                loaderElm.classList.remove('loader');
              }
            })
            .catch(e => {
              console.error(e);
            });
        };

        const productRecommendationsSection = document.querySelector('.product-recommendations');
        const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

        observer.observe(productRecommendationsSection);
      } catch (error) {
        console.error('Error initializing recommended products:', error);
      }
    }
  }

  window.CartDrawerRecommend = CartDrawerRecommend;

  customElements.define('cart-drawer-recommend', CartDrawerRecommend);

}

if (!customElements.get('recommend-quickshop')) {
  class RecommendQuickshop extends HTMLElement {
    constructor() {
    super();
      this.init();
    }

    /**
     * Initialize the quickshop for the recommend component
     */
    init() {
      this.cartItems = document.querySelector('cart-items');

      this.querySelector('select').addEventListener('change', (event) => {
        this.addToCart(event.target.value);
      });
    }

    /**
     * Add the variant to the cart
     * @param {string/int} - variantId
     * @returns
     */
    async addToCart(variantId) {
      if (!variantId) {
        return;
      }

      try {
        // Add the cart drawer loader
        this.cartItems && this.cartItems.enableLoading();

        // Fetch the cart
        const body = JSON.stringify({
          items: [
            {
              id: parseFloat(variantId),
              quantity: 1,
              properties: {
                _recommended: true,
              }
            }
          ],
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });

        // Add the item to the cart
        const data = await fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }}).then(response => response.json());

        // Fetch the current cart
        const currentCart = await fetch('/cart.js').then(response => response.json());

        // Update HTML
        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(data.sections[section.section], section.selector);
        }));

        // Reload the cart recommendations directly
        document.querySelectorAll('cart-drawer-recommend').forEach((recommendEl) => {
          recommendEl.classList.add('reload');
          if (recommendEl.initRecommendations) {
            recommendEl.initRecommendations();
          }
        });

        // Update free gift
        document.querySelectorAll('free-gift').forEach((freeGift) => {
          freeGift.update(currentCart);
        });

        // Update progress bar
        document.querySelectorAll('progress-bar').forEach((progressBar) => {
          progressBar.update(currentCart);
        });


        // Handle the scroll height
        document.querySelector('cart-drawer')?.handleScrollHeight();

        // Remove the cart drawer loader
        this.cartItems && this.cartItems.disableLoading();

        // Select the first option again
        this.querySelector('select').selectedIndex = 0;

      } catch (error) {
        this.cartItems && this.cartItems.disableLoading();
        console.error('Error fetching cart', error);
      }

    }

    /**
     * Sections to render after cart/donation update
     * @returns {object}
     */
    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-cart-item-contents',
        },
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-cart-bubble-contents',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-cart-footer-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        }
      ];
    }

    /**
     * Get section Inner html
     * @param {string} html
     * @param {string} selector
     * @returns DOM
     */
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }

  window.RecommendQuickshop = RecommendQuickshop;

  customElements.define('recommend-quickshop', RecommendQuickshop);

}

